import { render, staticRenderFns } from "./PreviewAsset.vue?vue&type=template&id=2f81d04a&scoped=true"
import script from "./PreviewAsset.vue?vue&type=script&lang=js"
export * from "./PreviewAsset.vue?vue&type=script&lang=js"
import style0 from "./PreviewAsset.vue?vue&type=style&index=0&id=2f81d04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81d04a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg,VTextField})
